import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[app-digit-only]',
  standalone: false
})
export class DigitonlyDirective {
  @Input() precision: number = 2;
  constructor() {}

  // Prevent user from pasting data with alphabet
  @HostListener('paste', ['$event'])
  onPaste(event: any) {
    var clipData = event.clipboardData?.getData('text');

    if (clipData) {
      const alphaRegex = /[a-zA-Z]/;
      var isInvalid = alphaRegex.test(clipData);
      if (isInvalid) event.preventDefault();
    } else {
      event.preventDefault();
    }
  }

  // Prevent user to enter anything but digits and decimal separator
  @HostListener('keypress', ['$event'])
  onKeyPress(event: any) {
    const key = event.which || event.keyCode || 0;
    if (key !== 46 && key > 31 && (key < 48 || key > 57)) {
      event.preventDefault();
    }
  }
}
